import { createAction, props } from '@ngrx/store';
import { ReportSection } from '../../core/models/report-sections';
import { CreateProfileReportDto } from '../models/profile-report.models';
import { ProfileReportLayout } from '../models/profile-report-sections';

export const createProfileReport = createAction(
  '[Reporting] Create Profile Report',
  props<{ request: CreateProfileReportDto; sections: ReportSection[]; layout?: ProfileReportLayout }>()
);
